import { Body, Heading, VStack, useTheme } from '@hover/blueprint';
import { iUpload } from '@hover/icons';
import React from 'react';

import { BasicCard } from 'src/modules/homeownerApp/components/Card';
import { Button } from 'src/shared/components';

import { useProTranslate } from '../../hooks';

const TryItCard = () => {
  const t = useProTranslate();
  const { colors } = useTheme();

  return (
    <BasicCard
      backgroundColorProp={colors.neutral[100]}
      height="100%"
      padding={700}
      width="100%"
    >
      <VStack
        alignItems="flex-start"
        height="100%"
        justifyContent={{ base: 'center', tablet: 'space-between' }}
      >
        <VStack alignItems="flex-start" pb={{ base: 500, tablet: 0 }}>
          <Heading size={500}>{t('tryItCard.header')}</Heading>
          <Body size={400} textColor="neutral.600">
            {t('tryItCard.subHeader')}
          </Body>
        </VStack>
        <Button iconBefore={iUpload} width={{ base: 'unset', tablet: '100%' }}>
          {t('tryItCard.buttonText')}
        </Button>
      </VStack>
    </BasicCard>
  );
};

export { TryItCard };
